import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
// import Button from "components/CustomButtons/Button.js";
import { Button, Grid, makeStyles } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import ToastModal from "views/components/ToastModal";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { useDispatch, useSelector } from "react-redux";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { toCamelCase } from "utils/Utils";
import { formatAmount } from "utils/Utils";
import { formatTimestamp } from "utils/Utils";
import { saveUserLeadId } from "store/reducers/login/LoginSlice";
import { parseDateMDY } from "utils/Utils";
import BottomButton from "components/UpdateUi/BottomButton/BottomButton";

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "90vh",
    overflow: "hidden",
  },
  headerText: {
    fontSize: 25,
    marginTop: 24,
    marginBottom: 16,
    color: "#111",
    textAlign: "center",
    lineHeight: "24px",
    fontWeight: "bold",
    fontFamily: theme.typography.fontFamily,
  },
  subHeader: {
    fontSize: 25,
    textAlign: "center",
    margin: "0 2%",
    color: "#111",
    lineHeight: "24px",
    fontWeight: "bold",
    fontFamily: theme.typography.fontFamily,
    maxWidth: "400px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: 20,
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  image: {
    width: 120,
    height: 120,
    marginTop: "10%",
  },
  penaltyContainer: {
    padding: "16px",
    borderRadius: "8px",
    lineHeight: 1,
    fontSize: "14px",
    color: "#333",
  },
  tableContainer: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "440px",
    overflowY: "auto",
    borderRadius: "10px",
    backgroundColor: "#fff",
    position: "relative",
  },
  bottomContainer:{
    margin: "0px 30px 0 30px",
    padding: "16px",
    borderRadius: "12px",
    backgroundColor: "#fff",
   boxShadow: "0 0 10px rgba(0, 0, 0, 0.05)",
    fontFamily: "sans-serif",
    maxHeight: "100px",
    [theme.breakpoints.down(600)]: {
      margin:'0px',
      padding:'0px',
      backgroundColor:'transparent',
      boxShadow:'none'
    },
  }
}));

const RepaymentScheduleDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const { authToken } = useSelector((state) => state.login.authData);
  const { mobileNumber } = useSelector((state) => state.login.userData);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([
    { id: "id", label: "#" },
    { id: "principle", label: "Principal Amount" },
    { id: "interest", label: "Interest Amount" },
    { id: "installmentAmount", label: "Installment Amount" },
    { id: "dueDate", label: "Due Date" },
  ]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const toastUpdate = (type, message, showToast) => {
    console.log(type, message, showToast, "toastUpdate");
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
      getUserLoanDetails();
  }, []);

  const getUserLoanDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_LOAN_REPAYMENT_DETAILS_API + leadId,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    console.log(result?.data, "API DATA");
    parseIndicatorData(result?.data?.installments);
  };
  const parseIndicatorData = (data) => {
    let reportData = [];
    data &&
      data?.forEach((leadDetails, index) => {
        let row = {
          id: index + 1,
          principle: formatAmount(leadDetails?.principalAmount),
          interest: formatAmount(leadDetails?.interestAmount),
          installmentAmount: formatAmount(leadDetails?.installmentAmount),
          dueDate: parseDateMDY(leadDetails?.installmentDueDate),
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };

  const handleNext = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USER_CREATE_LOAN_NUMBER_CUSTOMER_ID_API,
      method: "POST",
      authToken: authToken,
      data: {
        leadApplicationId: leadId,
      },
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      navigate("/journey/BankDetails");
    }
  };
  return (
     <>
    <Grid container className={classes.container}>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label="Repayment Schedule"
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        <ColumnGroupingTable columns={tableColumns} rows={selectedTableData} styling/>
      </Grid>

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
          <Grid item xs={12} sm={12} md={12} style={{marginTop:20}}>
        <BottomButton
          button1="Next"
          button1click={handleNext}
        />
      </Grid>
     </>
  );
};

RepaymentScheduleDetails.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
};

export default RepaymentScheduleDetails;
